"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * destructConstructor
 * This is a helper function allowing constructors to take both
 * a list of parameters, or an object. Makes converting to objects
 * possible with backwards compatability.
 *
 * @param {string[]} keys
 * @param params
 * @returns {T}
 */
var logger_1 = require("./logger");
exports.destructConstructor = function (keys) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    if (typeof params[0] === "object") {
        return params[0];
    }
    logger_1.logger.warn("List of parameters provided to constructor. Providing an object is preferred.");
    if (keys.length !== params.length) {
        throw new Error("Mismatch between keys (" + keys.length + ") and parameters (" + params.length + ")");
    }
    return keys.reduce(function (accumulator, item, index) {
        var _a;
        Object.assign(accumulator, (_a = {}, _a[item] = params[index], _a));
        return accumulator;
    }, {});
};
